import { __esmMin as e } from "../../_virtual/_rolldown/runtime.es.js";
// libs/ui-lib/src/assets/icons/backRightIcon.svg?raw
var t, n = e((() => {
	t = "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"13\" cy=\"13\" r=\"12\" transform=\"rotate(-180 13 13)\" fill=\"white\" stroke=\"#B0B0B0\" stroke-width=\"0.76\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.75 8.91633L11.9084 7.75L16.75 12.625L11.9084 17.5L10.75 16.3337L14.4333 12.625L10.75 8.91633Z\" fill=\"#B0B0B0\"/>\n</svg>\n";
}));
n();
export { t as default, n as init_backRightIcon };
